
import FullscreenVideoPlayer from '../generic/FullscreenVideoPlayer.vue';
import IconVideoPlayer from '../icons/IconVideoPlayer.vue';
export default {
  components: { IconVideoPlayer, FullscreenVideoPlayer },
  methods: {
    openVideo () {
      if (this.$refs.videoplayer) {
        this.$refs.videoplayer.openVideoPlayer();
        this.$refs.videoplayer.play();
      }
    }
  }

};
